import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { CheckoutForm } from './Widgets/CheckoutForm';
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { FloatLabel } from "primereact/floatlabel";
import { InputNumber } from "primereact/inputnumber";
import axios from "axios";
import { updateCountryLocalization } from "../../Actions/MopriSettingActions";


export const Topup = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [currency, setCurrency] = useState('');
    const [allowCheckout, setAllowCheckout] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState(null);
    const user = useSelector(state => state.userAuth);
    const mopriSettings = useSelector(state => state.mopriSettings);
    const internationalSettings = mopriSettings.internationalSettings;
    const gatewaySettings = mopriSettings.gatewaySettings;
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);
    const dispatch = useDispatch()
    const myToast = useRef(null);
    const localizationCurrency = useSelector(state => state.mopriSettings.internationalSettings.localizationCurrency);

    useEffect(() => {
        switch (localizationCurrency) {
            case 'Euro':
                setCurrency('€');
                break;
            case 'Pound Sterling':
                setCurrency('€');
                break;
            case 'South African Rand':
                setCurrency('R');
                break;
            case 'Namibian Dollar':
                setCurrency('N$');
                break;
            default:
                break;
        }
    }, []);

    useEffect(() => {
        if (!internationalSettings.localizationCountry) {
            getLocalizationSettings()
        } else {
            setIsLoading(false)
        }
    }, []);

    const getLocalizationSettings = () => {
        axios({
            method: 'get',
            url: `${apiURL}/api/getLocalizationSettings`,
            config: { headers: {'Content-Type': 'application/x-www-form-urlencoded' }}
        })
            .then((response) => {
                if (response.data.error) {
                    myToast.current.show({severity: 'error', summary: 'ERROR', detail: response.data.errorMessage, life: 5000});
                    setIsLoading(false)
                } else {
                    dispatch(updateCountryLocalization({
                        countryCode: response.data.localizationCountry,
                        countryCurrency: response.data.localizationCurrency,
                    }))
                    setIsLoading(false)
                }
            })
            .catch(function (error) {
                setIsLoading(false)
                myToast.current.show({severity: 'error', summary: 'ERROR', detail: 'There was an error while retrieving the localization settings.', life: 5000});
                console.error(error);
            });
    }

    const handleValueChange = (e) => {
        console.log('CHANGE', e)
        const newValue = e.value;
        setPaymentAmount(newValue);
        if (newValue >= gatewaySettings.minTopupAmount) {
            setAllowCheckout(true);
        }
        console.log('Show Checkout', newValue >= gatewaySettings.minTopupAmount)
    };

    const handleBlur = () => {
        if (paymentAmount >= gatewaySettings.minTopupAmount) {
            setAllowCheckout(true);
        } else if (paymentAmount !== null) {
            myToast.current.show({
                severity: 'error',
                summary: 'ERROR',
                detail: `Your top up amount of ${paymentAmount} is less than the minimum ${gatewaySettings.minTopupAmount} amount required.`,
                life: 5000,
            });
        }
    };

    const cancelTopup = () => {
        setPaymentAmount(null);
        setAllowCheckout(false);
    }

    if (isLoading) {

    } else {
        return (
            <>
                <Toast ref={myToast}/>
                <Card title={`Account Topup ${paymentAmount ? `${currency}${paymentAmount}` : ''}`}>
                    <div className="grid">
                        <div className="col-12">
                            <div style={{marginTop: '10px'}}>
                                <div className="p-fluid grid formgrid">
                                    <div className="field col-12">
                                        <div className="p-fluid grid formgrid">
                                            <div className="field col-6" style={{paddingTop: '27px'}}>
                                                <FloatLabel>
                                                    <InputNumber
                                                        id="customPmtValue"
                                                        value={paymentAmount}
                                                        mode="currency"
                                                        currency={internationalSettings.localizationCountry}
                                                        currencyDisplay="code"
                                                        onValueChange={handleValueChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label htmlFor="customPmtValue">Enter the amount you want to top up
                                                        with?</label>
                                                </FloatLabel>
                                            </div>
                                            <div className="field col-6" style={{paddingTop: '27px'}}></div>
                                        </div>
                                    </div>
                                </div>

                                <CheckoutForm
                                    address1={user.address1}
                                    address2={user.address2}
                                    address3={user.address3}
                                    city={user.city}
                                    postalCode={user.postalCode}
                                    country={user.country}
                                    telNumber={user.telNumber}
                                    value={paymentAmount}
                                    cancelTopup={cancelTopup}
                                    currency={currency}
                                    allowCheckout={allowCheckout}
                                />
                            </div>
                        </div>
                    </div>
                </Card>
            </>
        )
    }
}
